import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { PlatformService } from '../../services/platform/platform.service';

export const globalPlatformGuard: CanActivateFn = (route) => {
  const platformService = inject(PlatformService);

  const mobile = route.queryParamMap.get('mobile');
  const device = route.queryParamMap.get('device');

  if (mobile) platformService.setMobile(parseInt(mobile, 10));
  if (device) platformService.setDevice(parseInt(device, 10));

  return true;
};
